import styled from "styled-components";

export const MobileViewContainer = styled.div`
  padding: 0 12px;
  display: none;
  @media (max-width: 560px) {
    display: block;
    padding: 0;
  }
`;

export const Heading = styled.div`
  border-radius: 4px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  height: 52px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  img {
    width: 46px;
  }
  h2 {
    font-size: 27px;
    color: #00446e;
    font-family: "latobold";
  }
`;

export const AccordionContainer = styled.div`
  .MuiAccordion-root {
    border-radius: 4px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    background-color: #fff;
    margin-bottom: 8px;
  }
  .MuiAccordion-root.Mui-expanded {
    margin: 8px 0 !important;
  }
  .MuiAccordionSummary-content {
    margin: 10px 0;
  }
  .MuiAccordionSummary-root {
    padding: 0 15px;
  }
  .MuiAccordionSummary-content.Mui-expanded {
    margin: 10px 0;
  }
  .MuiAccordionSummary-root.Mui-expanded {
    min-height: 51px;
  }
  .MuiAccordionSummary-content {
    .accordion-header {
      display: flex;
      justify-content: space-between;
      /* flex-direction: column; */
      flex: 1;
      gap: 4px;
      h3 {
        color: #000;
        font-size: 17px;
        font-family: "latobold";
        display: flex;
        align-items: center;
        gap: 4px;
        word-break: break-word;
        /* width: 65%; */
        /* span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            } */
      }

      p {
        font-size: 14px;
        font-family: "latobold";
        color: #00000087;
        text-align: right;
        margin: 0;
        &.green-bid-status {
          color: #44a019;
        }
      }
    }
  }

  .MuiAccordionDetails-root {
    padding: 0px 15px 8px;
    .accordion-detail-section {
      width: 100%;
      .text-section {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
        border-bottom: solid 1px #7070704d;
        padding: 9px 0;
        > div {
          display: grid;
          grid-template-columns: 1fr 1fr;
          width: 100%;
          gap: 6px;
          p {
            font-size: 16px;
            margin: 0;
            &.label-text {
              font-family: "latobold";
            }
          }
        }
      }
      .action-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-top: 8px;
        button {
          background: linear-gradient(
            rgb(97, 176, 31) 0%,
            rgb(39, 145, 27) 100%
          );
          padding: 5px 10px;
          border-radius: 5px;
          cursor: pointer;
          color: rgb(255, 255, 255) !important;
          font-size: 14px;
          max-height: 30px;
          font-family: "latobold";
          border: none;
        }
      }
    }
  }
`;
